import { Box } from '@mui/material'
import SecDimButton from '../../shared/SecDimButton/SecDimButton'
import Tooltip from '../../shared/Tooltip/Tooltip'
import { RegenerateSubscribeTooltip } from './drSecDimConfig'
import { summarisePreferences } from './drSecDimQuestionnaire'
import * as Styled from './DrSecDimStyles'

interface DrSecDimSummaryProps {
	customisation: UserCustomisation | null
	onEdit: () => void
	onRegenerate: () => void
	onCancel: () => void
	canRegenerate: boolean
}

function DrSecDimSummary({
	customisation,
	onEdit,
	onRegenerate,
	onCancel,
	canRegenerate,
}: DrSecDimSummaryProps) {
	const summary = customisation ? summarisePreferences(customisation) : []
	const tooltipTitle = canRegenerate ? '' : <RegenerateSubscribeTooltip />

	return (
		<Styled.ContentWrapper>
			<Styled.WizardContent>
				<Styled.PanelBody>
					<Styled.WizardHeading>Your preferences</Styled.WizardHeading>
					{summary.length > 0 ? (
						<Styled.SummaryCard>
							{summary.map(item => (
								<Styled.SummaryRow key={item.label}>
									<Styled.SummaryRowLabel>{item.label}</Styled.SummaryRowLabel>
									<Styled.SummaryRowValue>{item.value}</Styled.SummaryRowValue>
								</Styled.SummaryRow>
							))}
						</Styled.SummaryCard>
					) : (
						<Styled.StateMessage>No preferences saved yet.</Styled.StateMessage>
					)}
				</Styled.PanelBody>
				{/* Same footer grammar as the questionnaire: Cancel far left, the
				    action group right-aligned with the primary (Regenerate) rightmost
				    and the secondary (Edit) immediately to its left. */}
				<Styled.WizardFooter>
					<SecDimButton
						variant='outlined'
						sx={Styled.DESTRUCTIVE_OUTLINE_SX}
						onClick={onCancel}
						rounded
					>
						Cancel
					</SecDimButton>
					<Box sx={{ display: 'flex', gap: 1 }}>
						<SecDimButton
							variant='outlined'
							sx={Styled.SECONDARY_OUTLINE_SX}
							onClick={onEdit}
							rounded
						>
							Edit preferences
						</SecDimButton>
						<Tooltip
							title={tooltipTitle}
							placement='top'
							disableHoverListener={canRegenerate}
							disableFocusListener={canRegenerate}
							disableTouchListener={canRegenerate}
						>
							<span>
								<SecDimButton
									rounded
									sx={canRegenerate ? undefined : Styled.DISABLED_REGEN_SX}
									aria-disabled={canRegenerate ? undefined : 'true'}
									onClick={() => {
										if (canRegenerate) onRegenerate()
									}}
								>
									Regenerate pathway
								</SecDimButton>
							</span>
						</Tooltip>
					</Box>
				</Styled.WizardFooter>
			</Styled.WizardContent>
		</Styled.ContentWrapper>
	)
}

export default DrSecDimSummary
